module.exports = __webpack_public_path__ + "img/head_boy.a40213c7.png";